import { AuthService } from '@core/Web/services/AuthService';
import { useAuth } from '@core/gameengine/state/auth';
import { getAuthToken } from '@core/utils/authToken';

/** Resolve bearer token from AuthService, Zustand, or persisted storage. */
export function resolveAccessToken(): string | null {
  const token =
    AuthService.getInstance().getAccessToken() ??
    useAuth.getState().accessToken ??
    getAuthToken();

  if (token) {
    AuthService.getInstance().setAccessToken(token);
  }

  return token ?? null;
}

/** Wait until auth restore finishes and a token is available. */
export async function waitForAccessToken(
  maxMs = 10000
): Promise<string | null> {
  const immediate = resolveAccessToken();
  if (immediate && useAuth.getState().isReady) {
    return immediate;
  }

  const start = Date.now();
  while (Date.now() - start < maxMs) {
    const token = resolveAccessToken();
    if (token && useAuth.getState().isReady) {
      return token;
    }
    await new Promise(resolve => setTimeout(resolve, 50));
  }

  return resolveAccessToken();
}
